import React, { ReactNode } from "react";
import * as S from "./style";
export interface PopupProps {
  visible: boolean;
  setVisible: () => void;
  content?: ReactNode;
  onlyOk?: boolean;
  okEvent?: () => void;
  isOtherPage?: boolean;
  customClassName?: string;
  isNotMarginTop?: boolean;
  btnMin?: boolean;
  mypage?: boolean;
  noBtn?: boolean;
  className?: string;
  textCancel?: string;
  textOk?: string;
  noFixedBtn?: boolean;
  title?: string;
}

const Popup: React.FC<PopupProps> = ({
  visible,
  setVisible,
  content,
  onlyOk,
  okEvent,
  isOtherPage,
  isNotMarginTop = false,
  btnMin,
  mypage,
  noBtn,
  className,
  textCancel,
  textOk,
  noFixedBtn = false,
  title,
}) => {
  return (
    <S.ModalPopup
      visible={visible}
      width={"max-content"}
      top={isOtherPage ? "100px" : ""}
      closable={false}
      footer={null}
      onCancel={() => setVisible()}
      className={`${className} ${noFixedBtn ? "noFixedBtn" : ""}`}
      centered
    >
      <S.Container className={isOtherPage ? `otherpage-popup-container` : ""}>
        <div className="title">{title}</div>
        <div className="content">{content}</div>
        {!noBtn && (
          <S.WrapperButton
            isNotMarginTop={isNotMarginTop}
            mypage={mypage}
            onlyOk={onlyOk}
            className={btnMin ? "min" : "wrapper-btn"}
          >
            {!onlyOk ? (
              <>
                <S.ButtonCancel
                  className={isOtherPage ? "otherpage-popup-cancel" : ""}
                  onClick={() => setVisible()}
                >
                  {textCancel || "취소"}
                </S.ButtonCancel>
                <S.ButtonConfirm id="btn" onClick={okEvent}>
                  {textOk || "확인"}
                </S.ButtonConfirm>
              </>
            ) : (
              <S.ButtonConfirm onClick={okEvent}>확인</S.ButtonConfirm>
            )}
          </S.WrapperButton>
        )}
      </S.Container>
    </S.ModalPopup>
  );
};

export default Popup;
